var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 110,
    viewBox: "0 0 126 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_16618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.38 49.9389V103.239H12.6052V49.9389C12.6052 49.2216 12.8902 48.5337 13.3974 48.0265C13.9046 47.5193 14.5925 47.2344 15.3098 47.2344H98.6757C99.0309 47.2344 99.3825 47.3043 99.7107 47.4402C100.039 47.5761 100.337 47.7753 100.588 48.0265C100.839 48.2776 101.038 48.5758 101.174 48.9039C101.31 49.232 101.38 49.5837 101.38 49.9389Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1892 51.5007H16.7966V98.312H97.1892V51.5007Z",
    fill: "url(#paint0_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62256 102.203H108.363V103.784C108.363 105.273 107.771 106.701 106.719 107.754C105.666 108.807 104.237 109.399 102.748 109.399H11.2412C9.75208 109.399 8.32396 108.807 7.27101 107.754C6.21806 106.701 5.62651 105.273 5.62651 103.784V102.203H5.62256Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74 102.333C67.74 102.818 67.5475 103.282 67.2049 103.625C66.8624 103.968 66.3977 104.16 65.9132 104.16H48.0768C47.8366 104.161 47.5986 104.114 47.3765 104.022C47.1544 103.931 46.9526 103.796 46.7825 103.626C46.6125 103.457 46.4775 103.255 46.3855 103.033C46.2934 102.811 46.2461 102.573 46.2461 102.333",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.459 62.2397H73.908V109.407H101.38L101.459 62.2397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.502 78.3127H82.6699V97.4263H120.502V78.3127Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.721 66.4547H78.4553V78.3127H124.721V66.4547Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4495 73.651C85.133 73.651 85.6871 73.0969 85.6871 72.4134C85.6871 71.7299 85.133 71.1758 84.4495 71.1758C83.766 71.1758 83.2119 71.7299 83.2119 72.4134C83.2119 73.0969 83.766 73.651 84.4495 73.651Z",
    fill: "url(#paint1_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2613 73.651C89.9448 73.651 90.4989 73.0969 90.4989 72.4134C90.4989 71.7299 89.9448 71.1758 89.2613 71.1758C88.5778 71.1758 88.0237 71.7299 88.0237 72.4134C88.0237 73.0969 88.5778 73.651 89.2613 73.651Z",
    fill: "url(#paint2_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.51 66.4547V78.5935",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177 66.4547V78.5935",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.721 81.9385H78.4553V93.7966H124.721V81.9385Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4495 89.1347C85.133 89.1347 85.6871 88.5807 85.6871 87.8971C85.6871 87.2136 85.133 86.6595 84.4495 86.6595C83.766 86.6595 83.2119 87.2136 83.2119 87.8971C83.2119 88.5807 83.766 89.1347 84.4495 89.1347Z",
    fill: "url(#paint3_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2613 89.1347C89.9448 89.1347 90.4989 88.5807 90.4989 87.8971C90.4989 87.2136 89.9448 86.6595 89.2613 86.6595C88.5778 86.6595 88.0237 87.2136 88.0237 87.8971C88.0237 88.5807 88.5778 89.1347 89.2613 89.1347Z",
    fill: "url(#paint4_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.51 81.9385V94.0773",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177 81.9385V94.0773",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.721 97.4223H78.4553V109.28H124.721V97.4223Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4495 104.619C85.133 104.619 85.6871 104.065 85.6871 103.381C85.6871 102.698 85.133 102.143 84.4495 102.143C83.766 102.143 83.2119 102.698 83.2119 103.381C83.2119 104.065 83.766 104.619 84.4495 104.619Z",
    fill: "url(#paint5_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2613 104.619C89.9448 104.619 90.4989 104.065 90.4989 103.381C90.4989 102.698 89.9448 102.143 89.2613 102.143C88.5778 102.143 88.0237 102.698 88.0237 103.381C88.0237 104.065 88.5778 104.619 89.2613 104.619Z",
    fill: "url(#paint6_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.51 97.4223V109.561",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177 97.4223V109.561",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97973 83.6545H0.395264V34.7951C0.394745 33.0667 0.734765 31.3551 1.39583 29.7582C2.05689 28.1612 3.02607 26.7101 4.24804 25.4878C5.47001 24.2655 6.92078 23.2958 8.51755 22.6343C10.1143 21.9727 11.8258 21.6323 13.5542 21.6323H39.4647",
    stroke: "#05CB67",
    strokeWidth: 0.790798,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.57 1.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1243 22.348H104.136C105.363 22.3474 106.578 22.5887 107.711 23.0578C108.845 23.5269 109.875 24.2147 110.743 25.082C111.61 25.9493 112.299 26.979 112.768 28.1124C113.238 29.2457 113.479 30.4605 113.479 31.6873V62.2398",
    stroke: "#05CB67",
    strokeWidth: 0.790798,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.57 1.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.343 24.0245L81.7449 22.1345C81.7963 21.6007 81.82 21.0867 81.82 20.5529C81.82 20.0191 81.7884 19.5249 81.733 18.9713L85.3153 17.0576C85.426 16.9986 85.5122 16.9022 85.5586 16.7857C85.6049 16.6691 85.6084 16.5399 85.5684 16.421L84.1964 12.2416C84.1611 12.1346 84.0926 12.0417 84.0008 11.9762C83.9091 11.9108 83.7989 11.8764 83.6863 11.8778H83.6112L79.5979 12.463C79.0656 11.587 78.4513 10.7635 77.7632 10.0036L79.5386 6.35016C79.5927 6.2371 79.6054 6.10856 79.5743 5.9871C79.5432 5.86564 79.4704 5.759 79.3686 5.68587L75.81 3.11182C75.7084 3.0397 75.5848 3.00537 75.4606 3.01476C75.3364 3.02414 75.2194 3.07666 75.1298 3.16322L72.2276 5.99825C71.2672 5.58359 70.2687 5.26312 69.2463 5.04137L68.5346 1.04785C68.5116 0.924972 68.4465 0.813926 68.3506 0.733828C68.2546 0.653729 68.1337 0.60959 68.0087 0.608962H63.7582C63.6327 0.608037 63.5111 0.651627 63.4148 0.731993C63.3185 0.81236 63.2538 0.924285 63.2323 1.04785L62.5206 5.04137C61.498 5.26254 60.4995 5.58303 59.5393 5.99825L56.637 3.16322C56.5468 3.07635 56.4292 3.02371 56.3043 3.01432C56.1794 3.00494 56.0552 3.0394 55.953 3.11182L52.3944 5.68587C52.2939 5.76006 52.2223 5.86694 52.192 5.98816C52.1617 6.10939 52.1746 6.23739 52.2284 6.35016L54.0037 10.0036C53.3058 10.7805 52.686 11.6241 52.1532 12.5223L48.1359 11.9372H48.0608C47.9489 11.9365 47.8396 11.9714 47.7487 12.0367C47.6577 12.1021 47.5898 12.1946 47.5547 12.3009L46.1787 16.4803C46.1399 16.5997 46.1443 16.7289 46.1913 16.8454C46.2383 16.9618 46.3249 17.0579 46.4358 17.1169L50.0181 19.0306C49.91 20.069 49.91 21.1158 50.0181 22.1543L46.4199 24.0443C46.3094 24.1025 46.223 24.1979 46.1759 24.3136C46.1289 24.4294 46.1243 24.5581 46.1629 24.6769L47.5073 28.8642C47.5402 28.9717 47.6068 29.0658 47.6972 29.1327C47.7876 29.1996 47.897 29.2357 48.0094 29.2359H48.0845L52.1058 28.6783C52.6318 29.5809 53.245 30.4298 53.9365 31.2129L52.1335 34.8545C52.0789 34.9671 52.0656 35.0953 52.0959 35.2168C52.1263 35.3382 52.1983 35.4451 52.2995 35.5188L55.8581 38.1165C55.9492 38.1821 56.0583 38.218 56.1705 38.2193C56.3086 38.2205 56.4418 38.168 56.5421 38.073L59.4681 35.2578C60.4232 35.6806 61.4179 36.0077 62.4375 36.2344L63.1216 40.2358C63.1429 40.3591 63.2068 40.471 63.3022 40.5519C63.3976 40.6329 63.5184 40.6777 63.6435 40.6787H68.1946C68.3197 40.6777 68.4405 40.6329 68.5359 40.5519C68.6313 40.471 68.6952 40.3591 68.7165 40.2358L69.3966 36.2344C70.4176 36.0083 71.4137 35.6811 72.37 35.2578L75.2959 38.073C75.3861 38.1591 75.5037 38.2106 75.628 38.2186C75.7524 38.2265 75.8756 38.1904 75.976 38.1165L79.5346 35.5188C79.6357 35.445 79.7075 35.3379 79.7372 35.2163C79.7668 35.0947 79.7525 34.9665 79.6967 34.8545L77.8976 31.2129C78.5891 30.4298 79.2023 29.5809 79.7283 28.6783L83.7496 29.2359H83.8247C83.9371 29.2357 84.0466 29.1996 84.1369 29.1327C84.2273 29.0658 84.2939 28.9717 84.3268 28.8642L85.6712 24.6769C85.7096 24.5468 85.6971 24.407 85.6362 24.2858C85.5752 24.1646 85.4704 24.0712 85.343 24.0245ZM65.9012 31.2326H65.8222C63.0142 31.2221 60.325 30.098 58.345 28.1069C56.365 26.1157 55.2559 23.4203 55.2611 20.6123C55.2663 17.8042 56.3855 15.113 58.3729 13.1293C60.3604 11.1456 63.0537 10.0314 65.8617 10.0314C68.6698 10.0314 71.3631 11.1456 73.3505 13.1293C75.3379 15.113 76.4571 17.8042 76.4623 20.6123C76.4676 23.4203 75.3585 26.1157 73.3784 28.1069C71.3984 30.098 68.7093 31.2221 65.9012 31.2326Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9297 5.37345C67.9706 5.59974 68.0777 5.80878 68.2375 5.97418C68.3972 6.13958 68.6025 6.2539 68.8272 6.30263L68.938 6.32633C69.8755 6.5277 70.7907 6.82178 71.6701 7.20415L71.7729 7.24764C71.9843 7.33988 72.2183 7.36696 72.4451 7.3254C72.672 7.28384 72.8812 7.1755 73.0461 7.01432L74.8531 5.25086C75.0474 5.05895 75.3037 4.94244 75.5761 4.92216C75.8485 4.90188 76.1192 4.97913 76.3398 5.14013L77.2413 5.78859C77.4618 5.94812 77.6191 6.18016 77.6856 6.44405C77.7521 6.70794 77.7236 6.98684 77.6051 7.23181L76.5019 9.50931C76.4044 9.71716 76.3693 9.94886 76.4009 10.1763C76.4325 10.4037 76.5294 10.617 76.6798 10.7904L76.7549 10.8734C77.3946 11.5871 77.9628 12.3619 78.4512 13.1865L78.5105 13.2854C78.6302 13.4812 78.8041 13.6381 79.0111 13.737C79.2181 13.836 79.4494 13.8727 79.677 13.8429L82.1759 13.4752C82.4468 13.4358 82.7228 13.4936 82.9552 13.6384C83.1875 13.7831 83.3611 14.0055 83.4451 14.266L83.7931 15.3177C83.8773 15.5771 83.8675 15.8579 83.7656 16.1109C83.6637 16.3639 83.4761 16.573 83.2355 16.7016L81.0055 17.8878C80.8021 17.9964 80.6356 18.1631 80.5272 18.3665C80.4188 18.57 80.3733 18.8011 80.3966 19.0305V19.1452C80.4941 20.0956 80.4941 21.0535 80.3966 22.0039V22.1186C80.3749 22.3482 80.4219 22.579 80.5317 22.7818C80.6416 22.9846 80.8092 23.1501 81.0134 23.2573L83.2553 24.4435C83.4964 24.5708 83.6851 24.7787 83.7885 25.0309C83.8918 25.2831 83.9032 25.5637 83.8207 25.8235L83.4807 26.8792C83.3975 27.1386 83.2253 27.3603 82.9945 27.505C82.7637 27.6497 82.4891 27.7082 82.2194 27.67L79.7126 27.3221C79.4855 27.2946 79.2553 27.3333 79.0498 27.4336C78.8442 27.534 78.6721 27.6915 78.554 27.8874L78.4947 27.9863C78.0142 28.8149 77.4527 29.5937 76.8182 30.3112L76.7392 30.3982C76.59 30.5725 76.4946 30.7862 76.4644 31.0136C76.4342 31.241 76.4706 31.4722 76.5691 31.6793L77.692 33.9489C77.8121 34.1932 77.8426 34.4718 77.7783 34.7363C77.714 35.0007 77.559 35.2342 77.3402 35.3961L76.4426 36.0524C76.2223 36.2129 75.9525 36.2906 75.6805 36.2718C75.4086 36.253 75.152 36.1389 74.9559 35.9496L73.1331 34.198C72.9678 34.0387 72.7586 33.9325 72.5324 33.893C72.3062 33.8535 72.0734 33.8827 71.8639 33.9766L71.7571 34.0201C70.8906 34.4043 69.9888 34.7036 69.0645 34.9137L68.9537 34.9374C68.7294 34.9881 68.5251 35.1042 68.3667 35.271C68.2084 35.4378 68.103 35.6478 68.0641 35.8745L67.6371 38.3655C67.5914 38.6347 67.4521 38.8792 67.2437 39.0557C67.0354 39.2323 66.7714 39.3295 66.4983 39.3303H65.3912C65.1179 39.3317 64.8529 39.2364 64.6431 39.0613C64.4333 38.8862 64.2921 38.6426 64.2446 38.3734L63.8017 35.8864C63.7607 35.6601 63.6536 35.451 63.4939 35.2856C63.3341 35.1202 63.1289 35.0059 62.9042 34.9572C61.8935 34.74 60.9068 34.4234 59.9584 34.0122C59.7477 33.9203 59.5143 33.8934 59.2882 33.9349C59.0621 33.9765 58.8535 34.0847 58.6892 34.2455L56.8822 36.009C56.6869 36.2003 56.4304 36.3167 56.1578 36.3377C55.8851 36.3587 55.6139 36.2829 55.3916 36.1236L54.494 35.4752C54.272 35.316 54.1135 35.0832 54.0469 34.8182C53.9803 34.5532 54.0098 34.2733 54.1302 34.028L55.2255 31.7505C55.323 31.5427 55.3581 31.311 55.3265 31.0836C55.2949 30.8562 55.198 30.6428 55.0476 30.4694L54.9685 30.3864C54.3313 29.6707 53.7634 28.8961 53.2722 28.0733L53.2169 27.9744C53.0958 27.7752 52.9187 27.6161 52.7078 27.517C52.4968 27.4178 52.2613 27.383 52.0307 27.4169L49.5278 27.7846C49.2575 27.823 48.9824 27.7647 48.7509 27.6201C48.5194 27.4754 48.3465 27.2536 48.2625 26.9938L47.9146 25.9421C47.8293 25.6832 47.838 25.4024 47.9392 25.1493C48.0405 24.8962 48.2278 24.6869 48.4681 24.5582L50.7022 23.372C50.9055 23.2637 51.0717 23.0969 51.1796 22.8933C51.2874 22.6896 51.3318 22.4584 51.3071 22.2293V22.1146C51.2557 21.6243 51.232 21.1578 51.228 20.6872C51.2241 20.2167 51.2517 19.7502 51.2992 19.2559V19.1412C51.3218 18.912 51.2756 18.6812 51.1664 18.4784C51.0573 18.2755 50.8901 18.1098 50.6863 18.0025L48.4444 16.8163C48.2033 16.6891 48.0146 16.4812 47.9112 16.2289C47.8079 15.9767 47.7965 15.6961 47.879 15.4363L48.219 14.3806C48.3022 14.1212 48.4744 13.8995 48.7052 13.7548C48.936 13.6101 49.2106 13.5516 49.4803 13.5898L51.9832 13.9378C52.2112 13.9692 52.4433 13.9322 52.6503 13.8316C52.8572 13.7309 53.0296 13.5711 53.1457 13.3724L53.205 13.2735C53.6855 12.4449 54.2471 11.6661 54.8815 10.9486L54.9566 10.8616C55.1095 10.6894 55.2074 10.4754 55.2377 10.2471C55.268 10.0188 55.2293 9.78665 55.1266 9.5805L54.0077 7.31087C53.8853 7.06709 53.8534 6.78774 53.9179 6.52268C53.9824 6.25761 54.1389 6.0241 54.3596 5.86374L55.2531 5.20737C55.4741 5.04658 55.7446 4.96876 56.0172 4.98756C56.2898 5.00636 56.547 5.12058 56.7438 5.31018L58.5626 7.06181C58.7289 7.22102 58.9388 7.32708 59.1655 7.36652C59.3923 7.40596 59.6256 7.37695 59.8359 7.28321C60.7803 6.86383 61.7645 6.54063 62.7736 6.31846C62.998 6.2678 63.2023 6.1517 63.3607 5.98489C63.519 5.81808 63.6243 5.60806 63.6633 5.38137L64.0904 2.89034C64.1368 2.62145 64.2763 2.37743 64.4845 2.20104C64.6926 2.02466 64.9562 1.92713 65.2291 1.92554H66.3362C66.608 1.92948 66.8703 2.02671 67.079 2.2009C67.2878 2.37509 67.4303 2.61567 67.4829 2.88242L67.9297 5.37345ZM65.8933 31.4698C68.7698 31.4651 71.5266 30.3178 73.5573 28.2805C75.5879 26.2432 76.7261 23.4826 76.7214 20.6062C76.7166 17.7297 75.5694 14.9729 73.5321 12.9423C71.4948 10.9116 68.7343 9.77348 65.8578 9.7782H65.8143C62.9384 9.79076 60.1852 10.9441 58.159 12.9851C56.1329 15.026 54.9996 17.7876 55.008 20.6635C55.0237 23.5315 56.1726 26.277 58.2044 28.3013C60.2361 30.3256 62.9858 31.4646 65.8538 31.4698H65.8933Z",
    fill: "url(#paint7_linear_752_16618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8539 31.2681C71.7325 31.2681 76.498 26.5026 76.498 20.624C76.498 14.7454 71.7325 9.97986 65.8539 9.97986C59.9753 9.97986 55.2097 14.7454 55.2097 20.624C55.2097 26.5026 59.9753 31.2681 65.8539 31.2681Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.1862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9125 26.4877L59.4006 22.2253L61.1088 20.0151L64.3273 22.5061L69.4556 15.3098L71.7292 16.9309L64.9125 26.4877Z",
    fill: "url(#paint8_linear_752_16618)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_16618",
    x1: 16.7966,
    y1: 74.9044,
    x2: 97.1892,
    y2: 74.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_16618",
    x1: 604.118,
    y1: 524.484,
    x2: 619.613,
    y2: 524.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_16618",
    x1: 88.0237,
    y1: 72.4134,
    x2: 90.4949,
    y2: 72.4134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_752_16618",
    x1: 604.118,
    y1: 636.895,
    x2: 619.613,
    y2: 636.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_752_16618",
    x1: 639.053,
    y1: 636.896,
    x2: 654.523,
    y2: 636.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_752_16618",
    x1: 604.118,
    y1: 749.31,
    x2: 619.613,
    y2: 749.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_752_16618",
    x1: 639.053,
    y1: 749.31,
    x2: 654.523,
    y2: 749.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_752_16618",
    x1: -107143,
    y1: -609349,
    x2: -110431,
    y2: -609349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_752_16618",
    x1: 1911.52,
    y1: 606.175,
    x2: 2295.92,
    y2: 606.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_16618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.314,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.5205e20d0b72bf13b5cf906ed514e798.svg";
export { ForwardRef as ReactComponent };